export default function Spinner(){
    return (
        <div className="Spinner">
            <div className='spinner-border' role="status">
                <span className='sr-only'></span>
            </div>
        </div>
    )
}